import React, { Component } from 'react'
import FormConsultaCpaEnPlaya from './FormConsultaCpaEnPlaya'

class ConsultaCpaEnPlaya extends Component {
  render () {
    return (
      <div className='consulta-cpa-container'>
        <FormConsultaCpaEnPlaya />
      </div>
    )
  }
}

export default ConsultaCpaEnPlaya
